import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { DataProvider } from './contexts/DataContext';
import { Toaster } from './components/ui/sonner';

import LoginPage from './pages/LoginPage';
import HomePage from './pages/HomePage';
import ConciergePage from './pages/ConciergePage';
import KnowledgePage from './pages/KnowledgePage';
import ResourceDetailPage from './pages/ResourceDetailPage';
import AcademyPage from './pages/AcademyPage';
import CourseDetailPage from './pages/CourseDetailPage';
import PathwayDetailPage from './pages/PathwayDetailPage';
import CommunityPage from './pages/CommunityPage';
import InvestPage from './pages/InvestPage';
import ShowcasePage from './pages/ShowcasePage';
import DashboardPage from './pages/DashboardPage';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <AuthProvider>
      <DataProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/" element={<ProtectedRoute><HomePage /></ProtectedRoute>} />
            <Route path="/ask" element={<ProtectedRoute><ConciergePage /></ProtectedRoute>} />
            <Route path="/knowledge" element={<ProtectedRoute><KnowledgePage /></ProtectedRoute>} />
            <Route path="/knowledge/:id" element={<ProtectedRoute><ResourceDetailPage /></ProtectedRoute>} />
            <Route path="/academy" element={<ProtectedRoute><AcademyPage /></ProtectedRoute>} />
            <Route path="/academy/courses/:id" element={<ProtectedRoute><CourseDetailPage /></ProtectedRoute>} />
            <Route path="/pathways/:slug" element={<ProtectedRoute><PathwayDetailPage /></ProtectedRoute>} />
            <Route path="/community" element={<ProtectedRoute><CommunityPage /></ProtectedRoute>} />
            <Route path="/invest" element={<ProtectedRoute><InvestPage /></ProtectedRoute>} />
            <Route path="/showcase/:id" element={<ProtectedRoute><ShowcasePage /></ProtectedRoute>} />
            <Route path="/me" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster />
        </Router>
      </DataProvider>
    </AuthProvider>
  );
}

export default App;
